import React, { useEffect, useRef } from 'react';
import { translate } from '../../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';
import { useToast } from '../../../../../../providers/ToastProvider';
import { StockTriggerProductRequest } from '../../../../../../requests/stockTriggerRequest';
import { useRequest } from '../../../../../../requests/common/requestHook';
import { ReorderRuleProduct } from '../../ReorderRuleScreen';
import { ToastType } from '../../../../../components/Toast';

interface StockTriggerParsePaneProps {
  file: File;

  handleClose: () => void;

  reorderRuleProducts: Map<string, ReorderRuleProduct>;
  setReorderRuleProducts: (reorderRuleProducts: Map<string, ReorderRuleProduct>) => void;
}

export default function StockTriggerParsePane({
  file,
  handleClose,
  reorderRuleProducts,
  setReorderRuleProducts,
}: StockTriggerParsePaneProps) {
  const executed = useRef(false);
  const { showToast } = useToast();

  const [parse, { loading }] = useRequest(StockTriggerProductRequest.parse);

  const handleParse = async () => {
    try {
      const result = await parse(file);
      if (!result) return;

      const items: Map<string, ReorderRuleProduct> = new Map();
      for (const item of result) {
        items.set(item.productMasterDataId, {
          productMasterDataId: item.productMasterDataId,
          reorderQuantity: item.reorderQuantity.toString(),
          replenishQuantity: item.replenishQuantity.toString(),
        });
      }

      setReorderRuleProducts(new Map(items));

      showToast({
        type: ToastType.success,
        title: translate({ key: TranslationKey.parseStockTriggerSuccessfull, count: 'plural' }),
      });
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        title: translate({ key: TranslationKey.parseStockTriggerFailed, count: 'plural' }),
        content: error.message || translate({ key: TranslationKey.errorOccurred }),
      });
    } finally {
      handleClose();
    }
  };

  useEffect(() => {
    if (executed.current) return;
    executed.current = true;

    handleParse();
  }, []);

  return (
    <div className='flex h-full flex-col gap-2'>
      <div className='flex h-full w-full flex-col items-center justify-center gap-2'>
        <p className='title'>{translate({ key: TranslationKey.parseStockTriggerTitle, count: 'plural' })}</p>
      </div>
    </div>
  );
}
